import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cartUnselect",
  "use": "icon-cartUnselect-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cartUnselect\">\n<circle cx=\"7.5\" cy=\"7.5\" r=\"6.7\" stroke=\"#969696\" stroke-width=\"1.6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol